import { render, staticRenderFns } from "./traffic-light.vue?vue&type=template&id=755ad55b&scoped=true&"
import script from "./traffic-light.vue?vue&type=script&lang=js&"
export * from "./traffic-light.vue?vue&type=script&lang=js&"
import style0 from "./traffic-light.vue?vue&type=style&index=0&id=755ad55b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ad55b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
